module.exports = __webpack_public_path__ + "media/images/front/about/thumbnail_list-0ed386270ff8af6976a42d4f8cae557c.jpg";